import React from 'react';

import Button, { Size, Theme, Type } from 'common/components/Button';
import FollowButton from 'common/components/FollowButton';
import Hover from 'common/components/Hover';
import noop from 'common/tools/noop';
import trans from 'common/tools/translations/trans';

export type FollowUnfollowButtonProps = {
  follow?: () => Promise<void> | void;
  followButtonTheme?: Theme;
  followButtonType?: Type;
  followText?: string;
  followedText?: string;
  isFollowed?: boolean;
  size?: Size;
  unfollow?: () => Promise<void> | void;
  unfollowButtonTheme?: Theme;
  unfollowButtonType?: Type;
};

const defaultFollowedText = trans('userspace.my-community.user-card.followed');

const FollowUnfollowButton = ({
  follow = noop,
  followButtonTheme = 'inverse',
  followButtonType = 'ghost',
  followText,
  followedText = defaultFollowedText,
  isFollowed,
  size = 'sm',
  unfollow = noop,
  unfollowButtonTheme = 'white',
  unfollowButtonType = 'ghost'
}: FollowUnfollowButtonProps) =>
  isFollowed ? (
    <Hover forceHoverOnTouchDevices={false}>
      {({ isHovered }) => {
        const theme = isHovered ? 'danger' : unfollowButtonTheme;
        return (
          <Button
            theme={theme}
            type={unfollowButtonType}
            size={size}
            onClick={() => unfollow()}
            className={isHovered ? 'icon icon-cross' : 'icon icon-tick'}
          >
            {followedText}
          </Button>
        );
      }}
    </Hover>
  ) : (
    <FollowButton
      theme={followButtonTheme}
      type={followButtonType}
      size={size}
      onClick={() => follow()}
    >
      {followText}
    </FollowButton>
  );

export default FollowUnfollowButton;
